module.exports = __webpack_public_path__ + "static/media/ticket.1018be4c.svg";